import { render } from "./ChangeType.vue?vue&type=template&id=a0f84e84&scoped=true"
import script from "./ChangeType.vue?vue&type=script&lang=js"
export * from "./ChangeType.vue?vue&type=script&lang=js"

import "./ChangeType.vue?vue&type=style&index=0&id=a0f84e84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f84e84"]])

export default __exports__